export default "__VITE_ASSET__OoOzdpfx__"